import React, { useEffect, useState, useContext, useCallback } from "react";
import { fetchConsultation, fetchPreIntakeStatuses } from "../apis";

const InitialStateContext = React.createContext({});

const InitialStateProvider = ({ consultationId, ...props }) => {
  const [consultation, setConsultation] = useState(null);
  const [preIntakeStatuses, setPreIntakeStatuses] = useState(null);

  const loadConsultation = useCallback(async () => {
    setConsultation(
      await fetchConsultation(consultationId)
    );
  }, [consultationId]);

  useEffect(() => {
    if (consultationId && !consultation) {
      loadConsultation();
    }
  }, [consultationId, consultation, loadConsultation]);

  useEffect(() => {
    if (!preIntakeStatuses) {
      fetchPreIntakeStatuses()
        .then(setPreIntakeStatuses);
    }
  }, [preIntakeStatuses]);

  if (!consultation || !preIntakeStatuses) {
    return null;
  }

  return (
    <InitialStateContext.Provider
      {...props}
      value={{
        consultation,
        preIntakeStatuses,
        loadConsultation,
      }}
    />
  );
};

export const useInitialState = () => {
  const context = useContext(InitialStateContext);

  if (context === undefined) {
    throw new Error("useInitialState must be used within a InitialStateProvider");
  }

  return context;
};

export default InitialStateProvider;
